const MINUTES_IN_DAY = 24 * 60;
const MINUTES_IN_HOUR = 60;

export interface RescheduleAntecedence {
  days: number;
  hours: number;
  minutes: number;
}

/** Breaks the product's reschedule antecedence into the parts a message is built from. */
export const describeRescheduleAntecedence = (totalMinutes: number): RescheduleAntecedence => {
  if (totalMinutes <= 0) {
    return { days: 0, hours: 0, minutes: 0 };
  }

  return {
    days: Math.floor(totalMinutes / MINUTES_IN_DAY),
    hours: Math.floor((totalMinutes % MINUTES_IN_DAY) / MINUTES_IN_HOUR),
    minutes: totalMinutes % MINUTES_IN_HOUR,
  };
};
